<template>
    <div class="row">
        <div v-if="showCalculatedCompensation" class="small-12 columns">
            <template v-if="showError">
                <div data-alert class="alert-box radius result-box">
                    Da die von Ihnen für die zwischenzeitliche Nutzung Ihres Fahrzeugs zu leistende Entschädigung einen
                    möglichen Schadensersatzanspruch übersteigt, steht Ihnen aller Voraussicht nach kein Schadensersatzanspruch zu.
                </div>
            </template>
            <template v-else>
                <div v-if="hasNegativOrEqualMinValue" data-alert class="alert-box success radius result-box">
                    Sie haben vermutlich Anspruch auf mittleren Schadensersatz in Höhe bis zu
                    <br/>
                    <span class="result-euro">{{ convertCurrencyValueToString(calculatedAvgCompensationMax) }} Euro</span>
                </div>
                <div v-else data-alert class="alert-box success radius result-box">
                    Sie haben vermutlich Anspruch auf mittleren Schadensersatz in Höhe von
                    <br/>
                    <span class="result-euro">{{ convertCurrencyValueToString(calculatedAvgCompensationMin) }} Euro</span>
                    bis
                    <span class="result-euro">{{ convertCurrencyValueToString(calculatedAvgCompensationMax) }} Euro</span>
                </div>
                <div class="panel radius">
                    <h4 class="text-align-center">Wichtige Hinweise</h4>
                    <ul>
                        <li>
                            Dieses Tool dient nur der Geltendmachung des sogenannten mittleren Schadensersatzes, bei dem
                            das Fahrzeug in Ihrem Besitz verbleibt .
                        </li>
                        <li>
                            Wenn der Hersteller vorsätzlich gehandelt hat, steht Ihnen alternativ auch ein Anspruch auf großen
                            Schadensersatz in Höhe von {{ convertCurrencyValueToString(calculatedBigCompensation) }} €
                            GEGEN RÜCKGABE des Fahrzeugs an den Hersteller zu. Den großen Schadensersatz können Sie mithilfe
                            dieses Tools NICHT geltend machen.
                        </li>
                        <li>
                            Wenn der Hersteller den mithilfe dieses Tools geltend gemachten mittleren Schadensersatz leistet,
                            können Sie nachträglich – selbst für den Fall einer späteren Stilllegung Ihres Fahrzeugs – keinen
                            weiteren Schadensersatz, d.h. insbesondere keinen großen Schadensersatz, mehr beim Hersteller
                            einfordern.
                        </li>
                    </ul>
                </div>
            </template>
        </div>
        <div v-else class="small-12 columns not-valid-text">
            Bitte füllen Sie das Formular vollständig aus.
        </div>
    </div>
</template>

<script>
import Calculation from '../../helper/Calculation';

export default {
    name: 'CalculatedCompensationStep',
    props: {
        caseData: {
            type: Object,
            default: function()
            {
                return {
                    mandator_lawform:                       null,
                    mandator_prename:                       null,
                    mandator_surname:                       null,
                    mandator_mail:                          null,
                    mandator_iban:                          null,
                    second_mandator_lawform:                null,
                    second_mandator_prename:                null,
                    second_mandator_surname:                null,
                    manufacturer_id:                        null,
                    purchase_date:                          null,
                    emissions_type:                         null,
                    mileage_purchase:                       null,
                    mileage:                                null,
                    price:                                  null,
                    is_vehicle_sold:                        null,
                    was_new:                                null,
                    selected_compensation:                  null
                }
            }
        },
        isFormValid: Boolean
    },
    emits: ['isCompensationPossibleChange'],
    computed: {
        showCalculatedCompensation()
        {
            return this.isFormValid && Calculation.isCalculationPossible(this.caseData);
        },
        calculatedAvgCompensationMin()
        {
            if(this.showCalculatedCompensation)
                return Math.round(Calculation.calculateAvgCompensationMinWithUsingAdvantage(this.caseData));

            return 0;
        },
        calculatedAvgCompensationMax()
        {
            if(this.showCalculatedCompensation)
                return Math.round(Calculation.calculateAvgCompensationMaxWithUsingAdvantage(this.caseData));

            return 0;
        },
        calculatedBigCompensation()
        {
            if(this.showCalculatedCompensation)
                return (Math.round(Calculation.calculateBigCompensation(this.caseData) * 100)/100).toFixed(2);

            return 0;
        },
        showError()
        {
            if (this.showCalculatedCompensation)
                return Calculation.calculateAvgCompensationMaxWithUsingAdvantage(this.caseData) <= 0;

            return false;
        },
        hasNegativOrEqualMinValue()
        {
            let minValue = Calculation.calculateAvgCompensationMinWithUsingAdvantage(this.caseData);
            let maxValue = Calculation.calculateAvgCompensationMaxWithUsingAdvantage(this.caseData)
            return minValue <= 0 || minValue === maxValue;
        }
    },
    methods: {
        convertCurrencyValueToString(currencyValue)
        {
            return parseFloat(currencyValue).toLocaleString('de-DE');
        }
    },
    watch: {
        showError(newValue)
        {
            this.$emit('isCompensationPossibleChange', !newValue);
        }
    }
};
</script>

<style scoped>
.not-valid-text {
    top: 100px;
    text-align: center;
}

.text-align-center {
    text-align: center;
}

.result-box {
    font-size: 200%;
    text-align: center;
    color: white;
}

.result-euro {
    font-size: 125%;
    font-weight: bold;
}
</style>
